import React, { useState, useEffect } from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import EmployeeSearchAdmin from "../../common/empsearch/EmployeeSearchAdmin";
import { useHistory, useParams } from "react-router-dom";
import EilgableHoursPanel from "../dashboard/EilgableHoursPanel";
import UtilizationPanel from "../dashboard/UtilizationPanel";
import AdminTotalAvailablePanel from "./AdminTotalAvailablePanel";
import { getForConsultant_Admin } from "../../../apis/revshare/EligableHoursApi";
import { getUtilization_Admin } from "../../../apis/revshare/UtilizationApi";

const AdminRevShareDashboard = () => {
  const { employeeId } = useParams();
  const [isLoading, setIsLoading] = useState(true);
  const [eligableHours, setEligableHours] = useState([]);
  const [utilization, setUtilization] = useState({});
  const history = useHistory();

  useEffect(() => {
    async function fetchData() {
      if (employeeId) {
        setIsLoading(true);
        
        try {
          // Assuming these functions return data, not Redux actions
          // You might need to modify these API functions
          const hoursData = await getForConsultant_Admin(employeeId);
          const utilizationData = await getUtilization_Admin(employeeId);
          
          setEligableHours(hoursData);
          setUtilization(utilizationData);
          
        } catch (error) {
          console.error("Error loading RevShare data:", error);
          setEligableHours([]);
          setUtilization({});
        } finally {
          setIsLoading(false);
        }
      }
    }

    fetchData();
  }, [employeeId]);

  const handleEmployeeChange = (employee) => {

    // Reset state when employee changes
    setEligableHours([]);
    setUtilization({});
    
    history.push(`/revshare/dashboard/admin/${employee.employeeId}`);
  };

  return (
    <Container fluid>
      <Row className="mb-4">
        <Col lg={6}>
            <Card style={{marginTop: 25}}>
                <Card.Body>
                    <Card.Title>Employee</Card.Title>
                    <div>
                        <EmployeeSearchAdmin
                            onSelect={handleEmployeeChange}
                            preselectedEmployee={employeeId}
                            useRsEmployeeId={true}
                        />
                    </div>
                </Card.Body>
            </Card>
        </Col>
      </Row>

      {employeeId && (
        <>
          <Row>
            <AdminTotalAvailablePanel 
              employeeNumber={employeeId}
            />
          </Row>
          <Row>
            <Col>
              <EilgableHoursPanel data={eligableHours || []} isLoaded={!isLoading} />
            </Col>
            <Col>
              <UtilizationPanel 
                data={utilization || {}} 
                isLoaded={!isLoading} 
              />
            </Col>
          </Row>
        </>
      )}
    </Container>
  );
};

// No need for connect or mapStateToProps or mapDispatchToProps
export default AdminRevShareDashboard;